import * as React from "react";
import { Input, Button } from "antd";
import { MerchantButton } from "./component";
// Component To Show Remaining Merchants After Search
export default class ShowRemainingMerchants extends React.Component<any, any> {
  constructor() {
    super();
    this.state = { showAll: false };
  }

  componentWillReceiveProps() {
    this.setState({ showAll: false });
  }

  handleClick(key: string) {
    this.props.handleClick(key);
  }

  render() {
    return (
      <div className="contents">
        <br />
        {!this.state.showAll ? (
          <Button
            type="primary"
            onClick={() => {
              this.setState({ showAll: true });
            }}
          >
            Load More
          </Button>
        ) : (
          this.props.merchants
            .slice(this.props.MERCHANTS_ON_PAGE, 2000)
            .map(function (merchant: any) {
              return <MerchantButton merchant={merchant} key={merchant.id} />;
            })
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./client/modules/Merchant/components/ViewMerchants/show_remaining_merchants.tsx